import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CtaButton } from "./ui/CtaButton";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const heroCta = document.getElementById("hero-cta");
      if (!heroCta) return;
      setVisible(heroCta.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-19" data-mp="br2d92cqkp6r">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-20" data-mp="bq9gmu7hrg2c">
          <div className="animate-cta-shake mx-auto max-w-md" data-id="element-21" data-mp="2b3qnefzur92c">
            <CtaButton label="Get Reflexology 360° — $27" compact className="shadow-2xl" data-id="element-22" data-mp="2f4k70x69i1pf" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}